import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const fetchEditToken = () => RESTClient.postAuthenticatedObservable('v2/homepages/authenticate', {});
